import { EGlyphicon } from "source/app/presentation/Shared/Glyphicon/EGlyphicon";
import { StyleClass } from "source/app/presentation/Shared/Styles/CSS";
import { ESaveState } from "./ESaveState";

export const saveStateDetails = [
    {
        saveState: ESaveState.saved,
        styleClass: StyleClass(`quickSaveIcon_workflowNodes_saved`, {
            color: "yellowgreen",
            opacity: 1
        }),
        icon: EGlyphicon["floppy-saved"],
    },
    {
        saveState: ESaveState.unsaved,
        styleClass: StyleClass(`quickSaveIcon_workflowNodes_unsaved`, {
            color: "#ffcebc",
            opacity: 0.5
        }),
        icon: EGlyphicon["floppy-disk"],
    },
    {
        saveState: ESaveState.saving,
        styleClass: StyleClass(`quickSaveIcon_workflowNodes_saving`, {
            color: "gold",
            opacity: 0.7
        }),
        icon: EGlyphicon["floppy-open"],
    },
];
